<template>
  <v-container>
    <!-- 頂部狀態切換按鈕 -->
    <div class="d-flex align-center mb-6">
      <v-btn-toggle
        v-model="statusFilter"
        mandatory
        class="mr-4"
      >
        <v-btn value="unsolved" text>
          未解決
        </v-btn>
        <v-btn value="solved" text>
          已解決
        </v-btn>
      </v-btn-toggle>

      <!-- <v-text-field
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        placeholder="輸入關鍵字搜尋"
        outlined
        dense
        hide-details
        class="flex-grow-1"
      ></v-text-field> -->
    </div>

    <!-- 修改表格內容 -->
    <v-data-table
      :headers="headers"
      :items="filteredReports"
      :search="search"
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr>
          <td class="text-start">{{ formatDate(item.createdAt) }}</td>
          <td class="text-start">{{ item.student.name }}</td>
          <td class="text-start">{{ item.student.username }}</td>
          <td class="text-start">{{ item.description }}</td>
          <td class="text-right" >
            <div class="d-flex align-center">
              <v-icon small @click="viewReport(item)">
                mdi-eye
              </v-icon>
              <v-btn
                v-if="!item.resolve"
                x-small
                outlined
                color="black"
                class="ml-2"
                @click="markAsSolved(item)"
              >
                標示為完成
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <!-- 回報詳情對話框 -->
    <v-dialog v-model="dialog" max-width="1200px">
      <v-card v-if="selectedReport">
        <v-card-text>
          <v-container>
            <div class="black-bg pa-4 mb-4 mt-4">
              <!-- 修改圖片顯示方式 -->
              <v-img
                :src="selectedReport.pictureUrl"
                alt="Report Image"
                contain
                height="100%"
              ></v-img>
            </div>

            <v-textarea
              v-model="selectedReport.reportReply"
              label="回饋內容"
              outlined
              rows="4"
              class="mb-4"
            ></v-textarea>

            <v-btn
              color="black"
              dark
              block
              @click="submitFeedback"
            >
              {{ selectedReport.resolve ? '更新回饋' : '完成回饋'}}
            </v-btn>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ReportService from '../../services/report.service';
import baseUrl from '../../../baseUrl.config'
import moment from 'moment'
export default {
  name: 'TeacherReports',
  data() {
    return {
      search: '',
      dialog: false,
      statusFilter: 'unsolved', // 修改預設值為 'unsolved'
      headers: [
        { text: '回報日期', value: 'createdAt', width: '15%', align: 'start' },
        { text: '姓名', value: 'student.name', width: '15%', align: 'start' },
        { text: '學號', value: 'student.username', width: '15%', align: 'start' },
        { text: '回報內容', value: 'description', width: '45%', align: 'start' },
        { text: '操作', value: 'actions', width: '10%', align: 'start', sortable: false }
      ],
      reports: [

      ],
      selectedReport: null
    }
  },
  computed: {
    filteredReports() {
      return this.reports.filter(report => {
        if (this.statusFilter === 'solved') {
          return report.resolve === true
        }
        return report.resolve === false
      })
    }
  },
  mounted() {
    this.getReports()
  },
  methods: {
    getReports() {
      ReportService.getBySchool()
        .then(response => {
          console.log(response)
          this.reports = response.data.reports
        })
        .catch(error => {
          console.log(error)
        })
    },
    viewReport(report) {
      this.selectedReport = { ...report }
      if(this.selectedReport.resolve === true) {
        this.selectedReport.reportReply = report.reportReply
      } else {
        this.selectedReport.reportReply = ''
      }
      if(this.selectedReport.pictureUrl) {
        this.selectedReport.pictureUrl = baseUrl + 'uploadFiles/report/' + this.selectedReport.pictureUrl
      }
      this.dialog = true
    },
    markAsSolved(report) {
      ReportService.update(report._id, {
        resolve: true,
        updateAt: new Date()
      })
        .then(response => {
          console.log(response)
          this.getReports()
        })
        .catch(error => {
          console.log(error)
        })
    },
    submitFeedback() {
      ReportService.update(this.selectedReport._id, {
        reportReply: this.selectedReport.reportReply,
        resolve: true,
        updateAt: new Date()
      })
        .then(response => {
          console.log(response)
          this.getReports()
        })
        .catch(error => {
          console.log(error)
        })
      this.dialog = false
      this.selectedReport = null
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>

<style scoped>
.v-data-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.v-data-table ::v-deep td {
  padding: 8px 16px !important;
}

.v-data-table ::v-deep th {
  font-weight: bold !important;
  white-space: nowrap;
}

.v-btn-toggle {
  background-color: white;
}

.v-btn-toggle .v-btn {
  border: 1px solid #e0e0e0;
}

.v-btn-toggle .v-btn.v-item--active {
  background-color: black !important;
  color: white !important;
}

.black-bg {
  background-color: black;
  border-radius: 4px;
  height: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
